import { render, staticRenderFns } from "./AdditionalQuestions.vue?vue&type=template&id=59cddfc2&scoped=true&"
import script from "./AdditionalQuestions.vue?vue&type=script&lang=js&"
export * from "./AdditionalQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalQuestions.vue?vue&type=style&index=0&id=59cddfc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cddfc2",
  null
  
)

export default component.exports